export default __webpack_public_path__ + "static/media/wShoes_1_p1.eec81d98.jpeg";